module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.10898/js/img/ServiceHub_Icon.svg"